import { AdvantagesSection as AdvantagesSectionData } from '@7chairs/types';
import beigeCurvyEgg from '../../../../assets/beigeCurvyEggRight.webp';
import {
  AdvantagesEggBg,
  AdvantagesSectionBlur,
  AdvantagesSectionContent,
  AdvantagesSectionSubtitle,
  AdvantagesSectionTable,
  AdvantagesSectionTableBody,
  AdvantagesSectionTitle,
  AdvantagesSectionWrapper,
} from './AdvantagesSection.style';
import { AdvantagesSectionRow } from './AdvantagesSectionRow';

interface AdvantagesSectionProps {
  data: AdvantagesSectionData;
  withRightEgg?: boolean;
  withPaddingBottom?: boolean;
}

export const AdvantagesSection = (props: AdvantagesSectionProps) => {
  const { data, withRightEgg = true, withPaddingBottom = true } = props;

  return (
    <AdvantagesSectionWrapper>
      <AdvantagesSectionContent withPaddingBottom={withPaddingBottom}>
        {withRightEgg && <AdvantagesEggBg src={beigeCurvyEgg} alt="" />}

        <AdvantagesSectionTitle>{data.title}</AdvantagesSectionTitle>
        <AdvantagesSectionSubtitle>{data.subtitle}</AdvantagesSectionSubtitle>
        <AdvantagesSectionTable>
          <AdvantagesSectionTableBody>
            {data.advantages.map((advantageRow, index) => (
              <AdvantagesSectionRow
                key={index}
                row={advantageRow}
                index={index}
                isLastRow={index === data.advantages.length - 1}
              />
            ))}
          </AdvantagesSectionTableBody>
        </AdvantagesSectionTable>
        <AdvantagesSectionBlur />
      </AdvantagesSectionContent>
    </AdvantagesSectionWrapper>
  );
};
